/*
  BODILY MODIFICATION (10.23.26): size-aware color swatches on bundle / multi-pack pickers
  Bundle pickers (<bundle-option-selects>, defined in product-info.js) only cross out an option
  based on the option before it, so Color never reflected the selected Size. After their own
  status update, this file:
  1. Hides colors that don't exist for the options chosen before Color (for example, Fit on the
     All-In Panty: Soft Hold and Original Wild Stretch have different color packs). If the selected
     color disappears, it moves the shopper to the first available color of the new Fit.
  2. Marks a color "disabled" (faded + strike, still clickable) when no in-stock variant has that
     color with every other value selected in the same row (Size, and Fit where it exists).
  Styling comes from component-swatch-availability.css. Loaded from snippets/product-variant-options.liquid.
*/
(function () {
  if (window.__bodilyBundleSwatchAvailability) return;
  window.__bodilyBundleSwatchAvailability = true;

  function labelFor(fs, input) {
    return input.id ? fs.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]') : null;
  }

  function updateColorAvailability(el) {
    try {
      const variants = el.getVariantData ? el.getVariantData() : [];
      if (!variants || !variants.length) return;

      const fieldsets = Array.from(el.querySelectorAll('fieldset'));
      const selected = fieldsets.map((fs) => fs.querySelector('input[type="radio"]:checked')?.value);
      let reselect = null;

      fieldsets.forEach((fs, position) => {
        const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
        if (!inputs.some((input) => /Color/.test(input.name))) return;

        inputs.forEach((input) => {
          // Exists for the options chosen before Color (e.g. Fit), regardless of size or stock
          const exists = variants.some(
            (v) =>
              v.options &&
              v.options[position] === input.value &&
              v.options.every((o, j) => j >= position || selected[j] === undefined || o === selected[j])
          );
          // In stock with every other selected option
          const available = variants.some(
            (v) =>
              v.available &&
              v.options &&
              v.options[position] === input.value &&
              v.options.every((o, j) => j === position || selected[j] === undefined || o === selected[j])
          );
          input.hidden = !exists;
          const label = labelFor(fs, input);
          if (label) label.style.display = exists ? '' : 'none';
          input.classList.toggle('disabled', !available);
        });

        const checked = inputs.find((i) => i.checked);
        if (checked && checked.hidden) {
          reselect =
            inputs.find((i) => !i.hidden && !i.classList.contains('disabled')) ||
            inputs.find((i) => !i.hidden) ||
            null;
        }
      });

      if (reselect) {
        reselect.checked = true;
        reselect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {
      console.error('Bundle swatch availability error', e);
    }
  }

  customElements.whenDefined('bundle-option-selects').then(() => {
    const BundleOptionSelects = customElements.get('bundle-option-selects');
    const original = BundleOptionSelects.prototype.updateVariantStatuses;
    if (typeof original !== 'function') return;

    BundleOptionSelects.prototype.updateVariantStatuses = function () {
      original.apply(this, arguments);
      updateColorAvailability(this);
    };

    // Apply to pickers already on the page
    document.querySelectorAll('bundle-option-selects').forEach((el) => updateColorAvailability(el));
  });
})();
